/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import {
	addChartSettings,
	removeChartSettings,
	setChartShowDecimatedData,
	setShowConfirmationForCustomGroups,
	setConfirmationMessageKey,
	incrementSeriesVisibilityResetToken,
	setChartUseSawtooth,
	setChartHasSawtoothData,
	setChartUseNormalizedDepol,
	setChartUseInterpolatedDepol,
	setShowSpatial,
	setChartPrimarySurveyId,
	setChartDepolSurveyId,
	setSelectedRemediationGroup,
	setSeriesVisibilityDataStore,
	setSeriesVisibility,
	setSeriesCache,


	setChartUseThreshold,
	setChartUseShadow,
	incrementInputThresholdResetToken,
	setChartPendingThresholds,
	setChartPendingLessNegativeThreshold,
	setChartPendingMoreNegativeThreshold,
	clearChartPendingThresholds,
	setChartThresholds,
	setChartLessNegativeThreshold,
	setChartMoreNegativeThreshold,

} from './actions';
import { EMPTY_OBJECT } from './constants';
import { createInitialChartSettings } from './util';

const selectHelper = (state, chartId) => {
	const { chartsSettings = EMPTY_OBJECT } = state;

	const chartSettings = chartsSettings[chartId] || createInitialChartSettings();

	return [chartsSettings, chartSettings];
};

// ************
// PARTS
// ************
const reducerParts = {
	[addChartSettings]: (
		state,
		{ payload: { chartId, settings = createInitialChartSettings() } }
	) => {
		const { chartsSettings } = state;
		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: settings
			}
		};
	},

	[removeChartSettings]: (state, { payload: { chartId } }) => {
		const { chartsSettings } = state;
		const newSettings = { ...chartsSettings };
		delete newSettings[chartId];
		return {
			...state,
			chartsSettings: newSettings
		};
	},

	[setChartShowDecimatedData]: (
		state,
		{ payload: { chartId, showDecimatedData = true } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					showDecimatedData
				}
			}
		};
	},

	[setShowConfirmationForCustomGroups]: (
		state,
		{ payload: { chartId, showConfirmation } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					showConfirmation
				}
			}
		};
	},

	[setConfirmationMessageKey]: (
		state,
		{ payload: { chartId, confirmationMessageKey } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					confirmationMessageKey
				}
			}
		};
	},

	[incrementSeriesVisibilityResetToken]: (
		state,
		{ payload: { chartId, token } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					seriesVisibilityResetToken: token
				}
			}
		};
	},

	[setChartUseSawtooth]: (state, { payload: { chartId, useSawtooth } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					useSawtooth
				}
			}
		};
	},

	[setChartHasSawtoothData]: (
		state,
		{ payload: { chartId, hasSawtoothData } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					hasSawtoothData
				}
			}
		};
	},

	[setChartUseNormalizedDepol]: (
		state,
		{ payload: { chartId, useNormalizedDepol } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					useNormalizedDepol
				}
			}
		};
	},

	[setChartUseInterpolatedDepol]: (
		state,
		{ payload: { chartId, useInterpolatedDepol } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					useInterpolatedDepol
				}
			}
		};
	},

	[setChartPrimarySurveyId]: (state, { payload: { chartId, surveyId } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					primarySurveyId: surveyId
				}
			}
		};
	},

	[setChartDepolSurveyId]: (state, { payload: { chartId, surveyId } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					depolSurveyId: surveyId
				}
			}
		};
	},

	[setSeriesVisibilityDataStore]: (
		state,
		{ payload: { chartId, dataStore = EMPTY_OBJECT } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					seriesVisibility: dataStore
				}
			}
		};
	},

	[setSelectedRemediationGroup]: (
		state,
		{ payload: { chartId, group, groupIndex } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);
		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					selectedRemediationGroup: group,
					selectedRemediationGroupIndex: groupIndex
				}
			}
		};
	},

	[setSeriesVisibility]: (
		state,
		{
			payload: {
				chartId,
				dataSetKey,
				visibilityFlagKey,
				propKey,
				isVisible,
				overwriteChildStore = false
			}
		}
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);
		const { seriesVisibility = {} } = chartSettings || {};
		const dataSetVisibility = seriesVisibility[dataSetKey] || {};
		const key = visibilityFlagKey || propKey;

		const newDataSetVisibility = overwriteChildStore
			? { [key]: isVisible }
			: { ...dataSetVisibility, [key]: isVisible };

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					seriesVisibility: {
						...seriesVisibility,
						[dataSetKey]: newDataSetVisibility
					}
				}
			}
		};
	},

	[setSeriesCache]: (state, { payload: { chartId, series } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);
		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					seriesCache: series
				}
			}
		};
	},

	[setShowSpatial]: (state, { payload: { chartId, showSpatial } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);
		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					showSpatial
				}
			}
		};
	},

	/**
	 * THRESHOLDS
	 */
	[setChartUseThreshold]: (state, { payload: { chartId, useThreshold } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					useThreshold,
					useShadow: !useThreshold
				}
			}
		};
	},	

	[setChartUseShadow]: (state, { payload: { chartId, useShadow } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					useThreshold: !useShadow,
					useShadow
				}
			}
		};
	},

	[incrementInputThresholdResetToken]: (
		state,
		{ payload: { chartId, token } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					inputThresholdResetToken: token
				}
			}
		};
	},	

	[setChartPendingThresholds]: (
		state,
		{ payload: { chartId, lessNegativeThreshold, moreNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					thresholdsPendingChangeRequiresConfirmation: true,
					thresholdsPendingThresholdsValue: {
						lessNegativeThreshold: lessNegativeThreshold, 
						moreNegativeThreshold: moreNegativeThreshold,
					}
				}
			}
		};
	},

	[setChartPendingLessNegativeThreshold]: (
		state,
		{ payload: { chartId, lessNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					thresholdsPendingChangeRequiresConfirmation: true,
					thresholdsPendingThresholdsValue: {
						...(chartSettings?.thresholdsPendingThresholdsValue || {}),
						lessNegativeThreshold: lessNegativeThreshold, 
					}
				}
			}
		};
	},

	[setChartPendingMoreNegativeThreshold]: (
		state,
		{ payload: { chartId, moreNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					thresholdsPendingChangeRequiresConfirmation: true,
					thresholdsPendingThresholdsValue: {
						...(chartSettings?.thresholdsPendingThresholdsValue || {}),
						moreNegativeThreshold: moreNegativeThreshold, 
					}
				}
			}
		};
	},

	[clearChartPendingThresholds]: (state, { payload: { chartId } }) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					thresholdsPendingChangeRequiresConfirmation: false,
					thresholdsPendingThresholdsValue: undefined
				}
			}
		};
	},

	[setChartThresholds]: (
		state,
		{ payload: { chartId, lessNegativeThreshold, moreNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					thresholdsPendingChangeRequiresConfirmation: false,
					thresholdsPendingThresholdsValue: undefined,
					lessNegativeThreshold: lessNegativeThreshold,
					moreNegativeThreshold: moreNegativeThreshold,
				}
			}
		};
	},	

	[setChartLessNegativeThreshold]: (
		state,
		{ payload: { chartId, lessNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					lessNegativeThreshold: lessNegativeThreshold,
				}
			}
		};
	},

	[setChartMoreNegativeThreshold]: (
		state,
		{ payload: { chartId, moreNegativeThreshold } }
	) => {
		const [chartsSettings, chartSettings] = selectHelper(state, chartId);

		return {
			...state,
			chartsSettings: {
				...chartsSettings,
				[chartId]: {
					...chartSettings,
					moreNegativeThreshold: moreNegativeThreshold,
				}
			}
		};
	},



};

export default reducerParts;
